import React, {createRef, useState, useContext} from 'react';
import {useQueryClient} from "react-query";
import {useAuth0} from "@auth0/auth0-react";
import moment from "moment";
import __ from "lodash";
import {withStyles} from "@material-ui/core/styles";
import MaterialTable from "@material-table/core";
import {defaultComponents} from "../../../controls/Material-Table-Components"
import {TablePagination, Select, MenuItem, Grid, IconButton, Tooltip, TextField, Typography, useTheme} from "@material-ui/core";
import {AddBox, NoteAdd} from "@material-ui/icons";


import {
  MaskedText,
  DatePicker,
  FlightNumber, 
  MaskedTime,
  AircraftSelect,
  ComboSelect,
} from "../../../controls";
import AddNotesDialog from "../../../controls/FormDialog";
import { ValidatorColumn, ColumnWidth } from "../../../blocks/ColumnHelper";
import StringToJSX from "../../../functions/StringToJsx";

// import AircraftListLookup from "../../Aircraft/components/AircraftListLookup";
import AirportLookup from "../../Airports/components/AirportsLookup";
import CountryLookup from "../../Settings/components/CountryLookup";
import PermitCompanyUuidLookup from "../../Companies/components/CompanyUuidLookup";
import PermitsValidator from "../validators/PermitsValidator";
// import PermitAircraftTooltip from "./PermitAircraftTooltip";
import PermitDatesTooltip from "./PermitDatesTooltip";
import CountryNameTooltip from "../../Settings/components/CountryNameTooltip";
import AirportNameTooltip from "../../Airports/components/AirportNameTooltip";
import generatePermitDialog from "./GeneratePermitDialog";

import { usePermits, useAddPermit, useUpdatePermit, useDeletePermit } from "../../../services/permits";
import SystemContext from "../../../SystemContext";
import {getApiSitePrefix} from "../../../functions/SiteDefaults";
import useColour, {getStatusColour} from '../../../services/settings/useColour';
import axios from 'axios';



const apiSitePrefix = getApiSitePrefix();
const dateFormat = "DD/MM/YYYY";
// const today = moment().toISOString();
const formatChars={
  "U": "[A-Z]",
  "A": "[A-Z0-9]",
  "a": "[A-Za-z0-9]",
  "i": "[A-Za-z0-9\\-]",
  "9": "[0-9]",
  "D": "[0-9.]",
  "-": "-",
  "x": "."
}

const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
    fontSize: 14,
  },
}))(Tooltip);

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 500,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
  },
}))(Tooltip);

const comboValues = [{"code":"CHARTER","value":"Magma"},{"code":"OPERATOR","value":"Operator"},{"code":"PARTNER","value":"Agent"}];

const PermitList = (_props) => {
  const {isAuthenticated} = useAuth0();
  const SystemData = useContext(SystemContext);
  const theme = useTheme();
  const validatorColumn = ValidatorColumn(PermitsValidator, true);

  const props = {
    ..._props
  }
  const [state, setState] = useState({
    canEdit: props.canEdit,
    activeRow: null,
  });
  const [permitNotes, setPermitNotes] = useState({
    showNoteDialog: false,
    rowData: null,
  });

  const year = props.year;
  const month = props.month;

  const tableRef = createRef({state: {lastEditingRow: false}});

  const handleAddPermit = useAddPermit();
  const handleUpdatePermit = useUpdatePermit();
  const handleDeletePermit = useDeletePermit();

  const queryClient = useQueryClient();
  const extraKeys = [year, month];

  const permits = usePermits({tableRef, queryClient, extraKeys});

  const colours = useColour({code: "PERMITS TEXT"});
  const backgroundColours = useColour({code: "PERMITS BACKGROUND"});

  const splitDates = (permit) => {
    SystemData.confirm(
      `Split Permit Dates`,
      `Are you sure you wish to Split the Permit Dates`,
      [
        {icon: "check_circle", value: true, label: "Yes", options: {color:"primary"}},
        {icon: "cancel", value: false, label: "No", options: {color:"secondary"}}
      ],
      (response) => {
        if (response) {
          axios.put(`${apiSitePrefix}/permit/split/${permit.rowData.permitUuid}`)
          .then(() => {
            queryClient.invalidateQueries(['Permits']);
          })
          .catch(err => {
            if (err.response && err.response.data && err.response.data.error) {
              SystemData.openAlert('Split Permit Dates Error', err.errorMessage);
            } else {
              SystemData.openAlert('Unexpected Error', 'An unexpected error occurred splitting the permit dates');
            }
          });
        }
      }
    );
  }

  const getColumns = (props) => {
    const baseColumn = {
      cellStyle: { fontSize:12, padding: "4px 2px" },
      headerStyle: { padding: "4px 2px" },
      editable: props.canEdit ? "always" : "never",
      emptyValue: "",
      initialEditValue: "",
      sorting: false
    };

    const defaultEditProps = {
      style:{fontSize: "0.875rem"}
    };

    return [
      {...validatorColumn},
      /*
        Can use ...ColumnWidth(70) to generate a fixed width column
      */

      // {
      //   ...baseColumn,
      //   ...(ColumnWidth(90)),
      //   title: "Arranged By",
      //   field: "arrangedBy",
      //   editable: state.canEdit ? "always" : "never",
      //   emptyValue: "",
      //   initialEditValue: "",
      //   render: rowData => {
      //     return (<div>{ (!rowData.arrangedBy) ? "" : __.find(comboValues, {code: rowData.arrangedBy}).value}</div>);
      //   },
      //   editComponent: (props) => {
      //     return (
      //       <Select
      //         value={props.value}
      //         onChange={
      //           (evt, data) => {
      //             const comboValue = __.find(comboValues, {value: data.props.value});
      //             props.onChange(comboValue.code);
      //           }
      //         }
      //         renderValue={(value) => {
      //           const comboValue = __.find(comboValues, {code: value});
      //           const valueToRender = (comboValue === undefined) ? "" : comboValue.value;
      //           return(`${valueToRender}`);
      //         }}
      //       >
      //         {(comboValues) ?
      //           comboValues.map((record) => {
      //             return (
      //               <MenuItem key={record.code} value={record.value}>{record.value}</MenuItem>
      //             );
      //           }) :
      //           null
      //         }
      //       </Select>
      //     )
      //   }
      // },
      {
        ...baseColumn,
        ...(ColumnWidth(110,undefined, undefined, {paddingLeft: 8}, {paddingLeft: 8})),
        title: "Permit Type",
        field: "permitType",
        editable: state.canEdit ? "onAdd" : "never",
        emptyValue: "",
        initialEditValue: "",
        sorting: true,
        editComponent: (props) => {
          const comboValues = [{"code":"OVERFLIGHT","value":"Overflight"},{"code":"LANDING","value":"Landing"},{"code":"DEPARTURE","value":"Departure"}];
          return (
            <Select
              value={props.value == null?'':props.value}
              onChange={
                (evt, data) => {
                  props.onChange(data.props.value);
                }
              }
              renderValue={(value) => `${value}`}
            >
              {(comboValues) ?
                comboValues.map((record) => {
                  return (
                    <MenuItem key={record.code} value={record.value}>{record.value}</MenuItem>
                  );
                }) :
                null
              }
            </Select>
          )
        }
      },
      {
        ...baseColumn,
        ...(ColumnWidth(100,undefined,undefined,undefined,{textAlign: "center"})),
        title: "Status",
        field: "status",
        editable: state.canEdit ? "always" : "never",
        emptyValue: "",
        initialEditValue: "REQUIRED",
        sorting: true,
        cellStyle: value => {
//          const color = value === 'REQUIRED' || value === 'REJECTED' ? "red" : value === 'REQUESTED' ? "orange" : "";
          const backgroundColor = getStatusColour(backgroundColours, value);
          const color = getStatusColour(colours, value);
          const {cellStyle} = ColumnWidth(100);
          return ({...cellStyle, color, backgroundColor, textAlign: "center", border: value==="RECEIVED"?undefined:`1px solid #d0d0d0`, fontWeight: 600});
        },
        render: rowData => (
          <ComboSelect
            group="PERMIT STATUS"
            subGroup=""
            value={rowData.status}
            displayOnly={true}
          />
        ),
        editComponent: (props) => {
          return (
            <ComboSelect
              group="PERMIT STATUS"
              subGroup=""
              fullWidth
              value={props.value}
              onChange={props.onChange}
            />
          )
        }
      },
      {
        ...baseColumn,
        ...(ColumnWidth(10,)),
      },
      {
        ...baseColumn,
        ...(ColumnWidth(65)),
        title: "Country Code",
        initialEditValue: "",
        field: "countryCode",
        sorting: true,
        editable: ((cell,rowData,updatedData) => {return ((rowData && rowData.permitType === "OVERFLIGHT") ? false : props.canEdit)}),
        editComponent: (props) => (
          <CountryLookup
            value={props.value}
            returnType={"object"}
            onChange={(returnObject) => {
              if (returnObject.found) {
                const country = returnObject.data
                const data = {
                  ...props.rowData,
                  countryCode: country.countryCode,
                  country: {countryName: country.countryName},
                }
                props.onRowDataChange(data);
              } else {
                props.onChange(returnObject.value);
              }
            }}
          />
        ),
        render: (rowData) => (
          <LightTooltip
            title={<CountryNameTooltip countryCode={rowData.countryCode} departureTime={rowData.departureTime}/>}
          >
            <div style={{width: 250, maxWidth:250, textOverflow: "ellipsis", whiteSpace:"nowrap", overflow: "hidden"}}>
              {rowData.countryCode}
            </div>
          </LightTooltip>
        ),
      },
      {
        ...baseColumn,
        ...(ColumnWidth(120)),
        title: "Country",
        field: "country.countryName",
        editable: "never",
        render: (rowData, type, updatedRowData) => {
          return (
          <LightTooltip
            title={<CountryNameTooltip countryCode={updatedRowData.countryCode} departureTime={updatedRowData.departureTime}/>}
          >
            <div style={{width:120, maxWidth:120, textOverflow: "ellipsis", whiteSpace:"nowrap", overflow: "hidden"}}>
              {updatedRowData.country.countryName}
            </div>
          </LightTooltip>
        )},
      },
      {
        ...baseColumn,
        ...(ColumnWidth(80)),
        title: "Airport",
        field: "airportCode",
        initialEditValue: "",
        sorting: true,
        editable: ((cell,rowData,updatedData) => {return ((rowData && rowData.permitType !== "OVERFLIGHT") ? false : props.canEdit)}),
        editComponent: (props) => (
          <AirportLookup
            value={props.value}
            onChange={props.onChange}
          />
        ),
        render: (rowData) => (
          <LightTooltip title={<AirportNameTooltip airportCode={rowData.airportCode} />}>
            <span> {rowData.airportCode} </span>
          </LightTooltip>
        ),
      },
      {
        ...baseColumn,
        ...(ColumnWidth(90, 2, 90)),
        title: "Aircraft",
        field: "permitAircraft",
//        editable: "never",
        render: (rowData) => (
          <LightTooltip
            title={rowData.permitAircraft.map((aircraft) => aircraft.aircraftTailNumber).join(', ')}
          >
            <div style={{width: 80, maxWidth:80, textOverflow: "ellipsis", whiteSpace:"nowrap", overflow: "hidden"}}>
              {rowData.permitAircraft.length>1?'Multiple':rowData.permitAircraft.map((aircraft) => aircraft.aircraftTailNumber).join(', ')}
            </div>
          </LightTooltip>
        ),
        editComponent: (props) => (
          <AircraftSelect 
            style={{height: 29}}
            chipsStyle={{height:29, overflow: "auto"}}
            values={props.rowData.permitAircraft.map((aircraft) => aircraft.aircraftTailNumber)}
            onChange={(values)=>{
              const permitAircraft = [];
              values.forEach(value => {
                const existing = __.find(props.rowData.permitAircraft, {aircraftTailNumber: value});
                if (existing) {
                  permitAircraft.push(existing);
                } else {
                  permitAircraft.push({aircraftTailNumber: value});
                }
              });
              props.onRowDataChange({...props.rowData, permitAircraft});
            }}
          />
        )
      },
      {
        ...baseColumn,
        ...(ColumnWidth(85, 8)),
        title: "Inbound Flight",
        field: "arrivalAirlineCode",
        initialEditValue: "",
        sorting: true,
        customFilterAndSearch: (term, rowData) => {
          const termUpper = `${term}`.toUpperCase();
          if (`${rowData.arrivalAirlineCode} ${rowData.arrivalFlightNo}`.indexOf(termUpper) !== -1) return true;
          if (`${rowData.arrivalAirlineCode}-${rowData.arrivalFlightNo}`.indexOf(termUpper) !== -1) return true;
          if (`${rowData.arrivalAirlineCode}${rowData.arrivalFlightNo}`.indexOf(termUpper) !== -1) return true;
          return false;
        },
        editComponent: (props) => (
          <FlightNumber
            mask={"XX-9999"}
            code={props.rowData.arrivalAirlineCode}
            number={props.rowData.arrivalFlightNo}
            inputProps={defaultEditProps}
            onChange={e => {
              const flightNo = parseInt(e.number);
              let data = { ...props.rowData, arrivalAirlineCode: e.code, arrivalFlightNo: flightNo };
              props.onRowDataChange(data);
            }}
          />
        ),
        render: (props) => (
          <div>
            {props.arrivalAirlineCode}&nbsp;{props.arrivalFlightNo}
          </div>
        ),
      },
      {
        ...baseColumn,
        ...(ColumnWidth(85, 8)),
        title: "Outbound Flight",
        field: "departureAirlineCode",
        initialEditValue: "",
        sorting: true,
        customFilterAndSearch: (term, rowData) => {
          const termUpper = `${term}`.toUpperCase();
          if (`${rowData.departureAirlineCode} ${rowData.departureFlightNo}`.indexOf(termUpper) !== -1) return true;
          if (`${rowData.departureAirlineCode}-${rowData.departureFlightNo}`.indexOf(termUpper) !== -1) return true;
          if (`${rowData.departureAirlineCode}${rowData.departureFlightNo}`.indexOf(termUpper) !== -1) return true;
          return false;
        },
         editComponent: (props) => (
          <FlightNumber
            mask={"XX-9999"}
            code={props.rowData.departureAirlineCode}
            number={props.rowData.departureFlightNo}
            inputProps={defaultEditProps}
            onChange={e => {
              const flightNo = parseInt(e.number);
              let data = { ...props.rowData, departureAirlineCode: e.code, departureFlightNo: flightNo };
              props.onRowDataChange(data);
            }}
          />
        ),
        render: (props) => (
          <div>
            {props.departureAirlineCode}&nbsp;{props.departureFlightNo}
          </div>
        ),
      },
      {
        ...baseColumn,
        ...(ColumnWidth(90)),
        title: "Days",
        field: "days",
        editable: ((cell,rowData,updatedData) => {return (rowData && !rowData.usePermitFlightDates)}),
        initialEditValue: "",
        editComponent: (props) => (
          <MaskedText
            mask={"D".repeat(7)}
            maskChar={""}
            alwaysShowMask={false}
            formatChars={formatChars}
            value={props.value}
            onChange={props.onChange}
            inputProps={defaultEditProps}
          />
        ),
        render: (rowData) => (
          <LightTooltip
            title={rowData.usePermitFlightDates
              ?
                <PermitDatesTooltip permitUuid={rowData.permitUuid} displayMode={"LIST"}/>
              :
                undefined
            }
          >
            <div style={{width: 90, maxWidth:90, textOverflow: "ellipsis", whiteSpace:"nowrap", overflow: "hidden"}}>
              {rowData.usePermitFlightDates
                ?
                  <PermitDatesTooltip permitUuid={rowData.permitUuid} style={{marginTop: -5}}/>
                :
                  rowData.days
              }
            </div>
          </LightTooltip>
        ),
      },
      {
        ...baseColumn,
        ...(ColumnWidth(10,)),
      },
      {
        ...baseColumn,
        ...(ColumnWidth(80)),
        title: "STD",
        field: "departureTime",
        editComponent: (props) => (
          <MaskedTime
            value={props.value}
            onChange={props.onChange}
          />
        ),
        render: (rowData) => (
          <LightTooltip
            title={ <CountryNameTooltip countryCode={rowData.countryCode} departureTime={rowData.departureTime}/> }
          >
            <div style={{width: 100, maxWidth:100, textOverflow: "ellipsis", whiteSpace:"nowrap", overflow: "hidden"}}>
              {rowData.departureTime}
            </div>
          </LightTooltip>
        ),
      },
      {
        ...baseColumn,
        ...(ColumnWidth(100)),
        title: "Route",
        field: "route",
        editComponent: (props) => (
          <MaskedText
            value={props.value}
            inputLabelProps={{ shrink: true }}
            style={{width: "100%"}}
            mask={"aaa-aaa-aaa"}
            maskChar={""}
            alwaysShowMask={false}
            formatChars={{ a: "[a-zA-Z]" }}
            forceUpperCase={true}
            onChange={value => {
              let trimmedRoute = `${value}`;
              if (trimmedRoute.length > 0 && trimmedRoute.charAt(trimmedRoute.length -1) === "-")
                trimmedRoute = trimmedRoute.substr(0, trimmedRoute.length -1);
              //console.log(trimmedRoute);
              props.onChange(trimmedRoute);
            }}
          />
        ),
        render: (rowData) => (
          <LightTooltip
            title={rowData.route}
          >
            <div style={{width: 100, maxWidth:100, textOverflow: "ellipsis", whiteSpace:"nowrap", overflow: "hidden"}}>
              {rowData.route}
            </div>
          </LightTooltip>
        ),
      },
      {
        ...baseColumn,

        title: "Permit No",
        field: "permitNo",
        initialEditValue: "",
        editComponent: (props) => (
          <MaskedText
            mask={"x".repeat(100)}
            maskChar={""}
            alwaysShowMask={false}
            formatChars={formatChars}
            value={props.value}
            onChange={props.onChange}
            inputProps={defaultEditProps}
          />
        )
      },
      {
        ...baseColumn,

        title: "Issued By",
        field: "company.companyName",
        initialEditValue: "",
        editComponent: (props) => (
          <PermitCompanyUuidLookup
            companyType={"PERMIT_SUPPLIER"}
            value={props.value}
            returnType={"object"}
            onChange={(returnObject) => {
              if (returnObject.found) {
                const permitSupplier = returnObject.data
                const data = {
                  ...props.rowData,
                  company: {companyName: permitSupplier.companyName},
                  companyUuid: permitSupplier.companyUuid,
                  companyCode: permitSupplier.companyCode,
                  branchCode: permitSupplier.branchCode
                }
                props.onRowDataChange(data);
              } else {
                props.onChange(returnObject.value);
              }
            }}
          />
        ),
      },
      {
        ...baseColumn,
        ...(ColumnWidth(100)),
        title: "Period From",
        field: "validFrom",
        customFilterAndSearch: (term, rowData) => {
          const searchDate = moment.utc(rowData.validFrom).startOf('day').format('DD MMM YYYY').toUpperCase();
          const termUpper = `${term}`.toUpperCase();
          return searchDate.indexOf(termUpper) !== -1
        },
        render: rowData => {
          const displayDate = moment.utc(rowData.validFrom).format(dateFormat);
          return (<div>{displayDate}</div>);
        },
        editComponent: (props) => (
          <DatePicker
            // minDate={today}
            value={props.value}
            disableToolbar={true}
            autoOk={true}
            format={dateFormat}
            onChange={props.onChange}
          />
        )
      },
      {
        ...baseColumn,
        ...(ColumnWidth(100)),
        title: "Period To",
        field: "validTo",
        render: rowData => {
          const displayDate = moment.utc(rowData.validTo).format(dateFormat);
          return (<div>{displayDate}</div>);
        },
        editComponent: (props) => (
          <DatePicker
            // minDate={today}
            value={props.value}
            disableToolbar={true}
            autoOk={true}
            format={dateFormat}
            onChange={props.onChange}
          />
        )
      },
      // {
      //   ...baseColumn,
      //   //...(ColumnWidth(300)),
      //   title: "Notes",
      //   field: "notes",
      //   initialEditValue: "",
      //   editComponent: (props) => (
      //     <MaskedText
      //       mask={"x".repeat(255)}
      //       maskChar={""}
      //       alwaysShowMask={false}
      //       formatChars={formatChars}
      //       value={props.value}
      //       onChange={props.onChange}
      //       inputProps={defaultEditProps}
      //     />
      //   )
      // },
    ];
  };

  const {actionPermit, dialogBox} = generatePermitDialog(SystemData, apiSitePrefix, queryClient, extraKeys, handleAddPermit, formatChars);

  return (isAuthenticated &&
    <div style={{width: "100%", marginLeft: 20, marginRight: 20}}>
      <MaterialTable
        tableRef={tableRef}
        style={{
          border: "none",
          boxShadow: "none",
          borderRadius: 0,
        }}
        options={{
          addRowPosition: "first",
          actionsColumnIndex: -1,
          cellStyle: {
            padding: "8px 2px",
          },
          headerStyle: {
            backgroundColor: theme.palette.tableHeader.backgroundColor,
            color: theme.palette.tableHeader.textColor,
            padding: "2px",
          },
          toolbarButtonAlignment: "right",
          pageSize: 15,
          detailPanelType: "single",
          padding: "dense",
        }}
        components={{
          ...defaultComponents,
          Pagination: (props) => (
            <TablePagination
              {...props}
              rowsPerPageOptions={[5, 10, 15]}
            />
          ),
        }}
        actions={[
          {
            hidden: false,
            disabled: false,
            icon: () => (
              <IconButton>
                <AddBox/>
              </IconButton>
            ),
            iconProps: { style: { color: theme.palette.primary.main }},
            tooltip: "Create New Permit",
            isFreeAction: true,
            onClick: actionPermit
          },
          (rowData) => (
            {
              hidden: false,
              disabled: false,
              icon: () => (
                <HtmlTooltip
                  rowData={rowData}
                  title={
                    <React.Fragment>
                      <Typography color="inherit">Permit Notes</Typography>
                      <div style={{ whiteSpace: "pre-wrap" }}>
                        <StringToJSX domString={"<span>" + rowData.notes + "</span>"}/>
                      </div>

                    </React.Fragment>
                  }
                >
                  <IconButton
                    variant="contained" color="primary" size={"small"}
                  >
                    <NoteAdd/>
                  </IconButton>
                </HtmlTooltip>),
              iconProps: { style: { color: theme.palette.primary.main }},
              isFreeAction: false,
              onClick: (e, rowData) => {
                setPermitNotes({showNoteDialog: true, rowData: rowData});
              }
            }
          ),
          (rowData) => (
            {
              hidden: false,
              disabled: rowData.status==='RECEIVED' || !rowData.usePermitFlightDates || moment(rowData.validFrom).isSame(moment(rowData.validTo)),
              icon: 'dynamic_feed',
              iconProps: { style: rowData.status==='RECEIVED' || !rowData.usePermitFlightDates || moment(rowData.validFrom).isSame(moment(rowData.validTo))?{}:{ color: theme.palette.primary.main }},
              tooltip: `Split Dates`, 
              isFreeAction: false,
              onClick: (e, rowData) => {
                splitDates({rowData: rowData});
              }
            }
          ),
        ]}
        title="Permit Management"
        columns={getColumns({canEdit: state.canEdit})}
        // detailPanel={
        //   [
        //     (rowData) => (
        //       {
        //         icon: () => {
        //           return(
        //             <LightTooltip
        //               title={<PermitAircraftTooltip permitUuid={rowData.permitUuid} suffix={" - click to edit permit aircraft"}/>}
        //             >
        //               <IconButton size={"small"}>
        //                 <Flight/>
        //               </IconButton>
        //             </LightTooltip>
        //           )
        //         },
        //         render: (rowData) => {
        //           return (
        //             <div style={{ backgroundColor: "#f2f2f2",}}>
        //               <div style={{ backgroundColor: "#f2f2f2", marginLeft: 40, marginRight: 40,}} >
        //                 <AircraftListLookup
        //                   canEdit={state.canEdit}
        //                   permitUuid={rowData.permitUuid}
        //                   width={400}
        //                 />
        //               </div>
        //             </div>
        //           );
        //         },
        //       }
        //     ),
        //   ]
        // }
        data={permits.data}
        editable={{
          isEditable: () => {
            return state.canEdit;
          },
          isDeletable: () => {
            return state.canEdit;
          },
          // onRowAdd: state.canEdit
          //   ? (newData) => new Promise((resolve, reject) => {
          //     handleAddPermit.mutate({record: newData, resolve, reject, extraKeys});
          //   })
          //   : undefined,
          onRowAdd: undefined,
          onRowUpdate: (newData, oldData) =>
            new Promise((resolve, reject) => {
              handleUpdatePermit.mutate({record: newData, oldRecord: oldData, resolve, reject, extraKeys});
            }),
          onRowDelete: (oldData) =>
            new Promise((resolve, reject) => {
              handleDeletePermit.mutate({oldRecord: oldData, resolve, reject, extraKeys});
            }),
        }}
      />

      {dialogBox}

      {permitNotes.showNoteDialog
        ?
        <AddNotesDialog
          title="Permit Notes"
          message=""
          open={permitNotes.showNoteDialog}
          record={{notes: permitNotes.rowData.notes}}
          dialogOptions={{maxWidth: "sm", fullWidth: true}}
          onChange={(result) => {
            if (result.buttonPressed === "save") {
              const newData = {...permitNotes.rowData, notes: result.record.notes};
              handleUpdatePermit.mutate({extraKeys, record: newData, oldRecord: permitNotes.rowData});
            }
            setPermitNotes({...permitNotes, showNoteDialog: false, rowData: null});
          }}
        >
          <Grid container checkChildren={true} spacing={3}>
            <Grid item xs={12} checkChildren={true}>
              <TextField
                id="notes"
                key="notes"
                label=""
                style={{width: "100%"}}
                variant={'outlined'}
                multiline
                rows={5}
                onChange={(value, props) => {
                  props.record = {...props.record, name: value};
                  props.onChange(value);
                }}
              />
            </Grid>
          </Grid>
        </AddNotesDialog>
        :
        <></>
      }

    </div>
  );

}

export default PermitList;
